import { createFileRoute } from '@tanstack/react-router'
import { useEffect, useState } from 'react'

import { useGetOrderReceiptUrl } from '@/api/react-query'
import { Text } from '@/components/base/text'
import { useI18n } from '@/i18n/i18n-react'

export const Route = createFileRoute('/_authenticated/_general/orders/$orderUuid/receipt')({
	component: ReceiptRoute
})

function ReceiptRoute() {
	const { orderUuid } = Route.useParams()
	const { L } = useI18n()
	const { data: receiptData, isLoading, error } = useGetOrderReceiptUrl({ orderUuid })
	const [redirecting, setRedirecting] = useState(false)

	useEffect(() => {
		if (receiptData?.receiptUrl) {
			setRedirecting(true)
			window.location.href = receiptData.receiptUrl
		}
	}, [receiptData])

	return (
		<div className='fixed inset-0 z-[100] flex flex-col items-center justify-center bg-white'>
			<div className='flex flex-col items-center gap-4'>
				{error ? (
					<Text className='text-ui-fg-error'>{L.OrderDetail.Receipt.FailedToLoad()}</Text>
				) : (
					<>
						<div className='h-8 w-8 animate-spin rounded-full border-2 border-ui-border-base border-t-ui-fg-base' />
						<Text size='small' className='text-ui-fg-muted'>
							{redirecting ? L.OrderDetail.Receipt.Redirecting() : L.OrderDetail.Receipt.Loading()}
						</Text>
					</>
				)}
			</div>
		</div>
	)
}
